module.exports = __webpack_public_path__ + "static/media/bicc_center_right.15757030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/bicc_center_right.jpg
// module id = 1116
// module chunks = 0